import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Box, Button, Card, Flex, Spinner, Text } from "@radix-ui/themes";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { DragAndDropFileUpload } from "../../../components/inputs/FileUpload/DragAndDropFileUpload";
import { routes } from "../../../routes";
import { uploadPaymentFile } from "../../../services/finance/paymentReference";

const UploadPaymentFileValidation = yup.object().shape({
  file: yup
    .mixed<File>()
    .required("O ficheiro é obrigatório")
    .test("fileFormat", "Apenas ficheiros .txt são permitidos", (value) =>
    value instanceof File ? value.name.toLocaleLowerCase().endsWith(".txt") : false
    ),
});

export default function UploadPaymentFile() {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      return await uploadPaymentFile(formData);
    },
    mutationKey: "uploadPaymentFile",
  });

  const {
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<{ file: File }>({
    resolver: yupResolver(UploadPaymentFileValidation),
    mode: "onBlur",
    reValidateMode: "onBlur",
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      await mutation.mutateAsync(data.file);
      toast.success(`Ficheiro carregado!`);
      reset();
    } catch (err: any) {
      toast.error(`Erro ao enviar o ficheiro: ${err?.message}`);
    }
  });


  const handleBack = () => {
    //navigate(routes.courses);
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1">
        <Flex direction="column" gap="4">
          <Box>
          <Text as="label" size="2"><span>Ficheiro de pagamento <Text color="red">*</Text></span></Text>
            <Controller
              name="file"
              control={control}
              render={({ field }) => (
                <DragAndDropFileUpload
                  onFileDrop={(file) => {
                    console.log("Ficheiro recebido no onFileDrop:", file);
                    field.onChange(file);
                  }}
                  label="Arraste ou selecione o ficheiro"
                  accept=".txt"
                  selectedFile={field.value}
                />
              )}
            />

            {errors.file && (
              <Text color="red" size="1">{`${errors.file.message}`}</Text>
            )}
          </Box>

          <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? (
                <Spinner loading>
                  <EnterIcon />
                </Spinner>
              ) : (
                <EnterIcon />
              )}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}
